import { Box, makeStyles, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@material-ui/core"
import { keyBy } from "lodash"
import React from "react"
import clsx from "clsx"

const useStylesAPIEnum = makeStyles(theme => ({
  colCode: { width: "25em" },
  colLibelle: { width: "20em" },
  deprecated: { textDecoration: "line-through" }
}))

export const APIEnum = ({ enumdef }) => {
  const classes = useStylesAPIEnum()
  return <Box m={2}>
    <a id={enumdef.code} />
    <Typography variant="h5" >{enumdef.code}</Typography>
    <Typography variant="body1"><p>{enumdef.label}</p></Typography>
    <Typography variant="body2"><p>{enumdef.description}</p></Typography>
    {enumdef.docComplements.length > 0 && <>
      <dl>
        {enumdef.docComplements.map(it => <><dt key={`dt_${it.code}`}>{it.title} : </dt><dd key={`dd_${it.code}`}>{it.description}</dd></>)}
      </dl>
    </>
    }

    <Table size="small">
      <TableHead>
        <TableRow>
          <TableCell className={classes.colCode}>Code</TableCell>
          <TableCell className={classes.colLibelle}>Libelle</TableCell>
          <TableCell>Description</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {enumdef.values.map(it => <APIEnumRow key={it.code} value={it} docComplements={enumdef.docComplements} />)}
      </TableBody>
    </Table>

  </Box>
}

export const APIEnumRow = ({ value, docComplements }) => {

  const classes = useStylesAPIEnum()
  const className = clsx({ [classes.deprecated]: value.deprecated })
  const docComplementsDefs = keyBy(docComplements, it=>it.code)
  const docComplementsEntries = Object.entries(value.docComplements)
  const docComplementsList = docComplementsEntries
    .map(([code, description]) => {
      return <li key={code}>{docComplementsDefs[code].title} : {description}</li>
    })
  return <TableRow id={value.code}>
    <TableCell className={className}>{value.code}</TableCell>
    <TableCell className={className}>{value.label}</TableCell>
    <TableCell>
      {value.deprecated && <p><span> <strong>Déprécié : </strong>{value.deprecatedMessage}</span></p>}
      {value.description && <p>{value.description}</p>}
      {docComplementsEntries.length > 0 && <ul>{docComplementsList}</ul>}
    </TableCell>
  </TableRow>
}
